/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

// Featured Customer Stories Slider js
(function () {

	if (!window.Swiper) {
		console.warn('Swiper library not loaded');
	};

	const featuredCustomerStoriesBlocks = document.querySelectorAll('.js-featured-customer-stories-wrapper');
	featuredCustomerStoriesBlocks.forEach((block, index) => {

		const thumbs = block.querySelector('.js-featured-customer-stories-slider__thumbs');
		const slider = block.querySelector('.js-featured-customer-stories-slider__slides');

		const thumbsSliderInstance = new Swiper(thumbs, {
			// loop: true,
			watchSlidesProgress: true,
			slidesPerView: 2.4,
			spaceBetween: 12,
			speed: 400,
			slideToClickedSlide: true,
			direction: 'horizontal',
			// shortSwipes:false,
			threshold: 20, // https://swiperjs.com/swiper-api#param-threshold
			breakpoints: {
				768: {
					direction: 'horizontal',
					spaceBetween: 20,
					slidesPerView: 'auto',
				},
				992: {
					direction: 'vertical',
					spaceBetween: 20,
					slidesPerView: 'auto',
				},
			},
		});

		const csSliderInstance = new Swiper(slider, {
			// loop: true,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			speed: 400,
			autoHeight: true,
			spaceBetween: 20,
			allowTouchMove: false,
			// observer: true, // https://stackoverflow.com/a/60768349
			// observeParents: true,
			// Navigation arrows
			thumbs: {
				swiper: thumbsSliderInstance,
				autoScrollOffset: 1,
			},
			breakpoints: {
				768: {
					thumbs: {
						swiper: thumbsSliderInstance,
						autoScrollOffset: 2,
					},
					spaceBetween: 40,
				},
			},
		});


		// Related testimonials slider
		const testimonialsSliders = block.querySelectorAll('.js-cs-related-testimonials-slider');
		testimonialsSliders.forEach((testimonialSlider, index) => {

			const numberOfSlides = testimonialSlider.querySelectorAll('.swiper-slide').length;

			const testimonialSliderInstance = new Swiper(testimonialSlider, {
				loop: numberOfSlides > 1 ? true : false,
				// loopAddBlankSlides: true,
				// loopAdditionalSlides: 3,
				// rewind:true,
				slidesPerView: 1,
				spaceBetween: 20,
				preloadImages: false,
				// lazy: {
				//   checkInView:true,
				//   loadPrevNext:true,
				//   enabled:true
				// },
				autoplay: {
				  delay: 6000,
				},
				speed: 400,
				autoHeight: false,
				nested: true,
				pagination: {
					el: testimonialSlider.closest('.js-featured-customer-story__testimonials-wrapper').querySelector('.swiper-pagination'),
					type: 'bullets',
					clickable: true
				},
				// threshold: 10, // https://swiperjs.com/swiper-api#param-threshold
			});
		});

	});





})();


